import React from "react";

function Home() {
  return <div>Please select a tab to begin</div>;
}

export default Home;
